"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GalleryCarouselNavComponent = void 0;

var React = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _svg = _interopRequireDefault(require("../svg"));

var _keyboardCommands = require("../keyboard-commands");

var _layoutConstants = _interopRequireDefault(require("../../util/layout-constants"));

require("./gallery-carousel-nav.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @typedef {object} GalleryCarouselNavItemData
 * @property {string} id Unique id for image
 * @property {string} title Title of the image, displayed below the image
 */

/**
 * @callback GalleryCarouselNavOnChange
 * @param {string} image The id of the image that moved to the front of the
 * carousel
 * @returns {void}
 */

/**
 * @typedef {object} GalleryCarouselNavProps
 * @property {GalleryCarouselNavItemData[]} data A list of items used to populate
 * items in the carousel
 * @property {string} currentTitle Id of the currently showing title
 * @property {GalleryCarouselNavOnChange} onChange Called when a new image moves to the
 *                                         front of the carousel
 */

/**
 * @class
 * @extends {React.Component<GalleryCarouselNavProps>}
 */
var GalleryCarouselNavComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(GalleryCarouselNavComponent, _React$Component);

  var _super = _createSuper(GalleryCarouselNavComponent);

  /** This is necessary for server-side rendering, where there is no global
   * window object */
  function GalleryCarouselNavComponent(props) {
    var _this;

    _classCallCheck(this, GalleryCarouselNavComponent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "resize", function () {
      if (!_this.containerRef.current) {
        return;
      }

      _this.setState({
        containerWidth: _this.containerRef.current.offsetWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nextImage", function () {
      var _this$props = _this.props,
          data = _this$props.data,
          currentTitle = _this$props.currentTitle,
          onChange = _this$props.onChange;
      var index = data.findIndex(function (i) {
        return i.id === currentTitle;
      });
      var nextImageIndex = (index + 1) % data.length;
      onChange(data[nextImageIndex].id);
    });

    _defineProperty(_assertThisInitialized(_this), "previousImage", function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          currentTitle = _this$props2.currentTitle,
          onChange = _this$props2.onChange;
      var index = data.findIndex(function (i) {
        return i.id === currentTitle;
      });
      var previousIndex = index === 0 ? data.length - 1 : index - 1;
      onChange(data[previousIndex].id);
    });

    _this.containerRef = /*#__PURE__*/React.createRef();
    _this.debouncedResize = _lodash["default"].debounce(_this.resize, GalleryCarouselNavComponent.resizeDebounceWait);
    _this.state = {
      containerWidth: 0
    };
    return _this;
  }

  _createClass(GalleryCarouselNavComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.resize(); // Fix issue that can occur when JavaScript is executed before styles are
      // applied to the page

      setTimeout(function () {
        return _this2.resize();
      });

      if (GalleryCarouselNavComponent.windowExists()) {
        // Fix issue that can occur when JavaScript is executed before styles are
        // applied to the page
        window.addEventListener('load', this.resize);
        window.addEventListener('resize', this.debouncedResize);
      }
    }
    /** Clean up event listeners and clear any animations that are in progress */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (GalleryCarouselNavComponent.windowExists()) {
        window.removeEventListener('load', this.resize);
        this.debouncedResize.cancel();
        window.removeEventListener('resize', this.debouncedResize);
      }
    }
    /** Adjust properties needed for layout */

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          currentTitle = _this$props3.currentTitle;
      var containerWidth = this.state.containerWidth;
      var mobileView = containerWidth < _layoutConstants["default"].small;
      var classes = (0, _classnames["default"])('GalleryCarouselNav', {
        'mobile-view': mobileView
      });
      /* eslint-disable jsx-a11y/click-events-have-key-events,
       jsx-a11y/no-static-element-interactions */

      return /*#__PURE__*/React.createElement("div", {
        className: classes,
        ref: this.containerRef
      }, /*#__PURE__*/React.createElement("div", {
        className: "GalleryCarouselNavItem"
      }, data.find(function (i) {
        return i.id === currentTitle;
      }).title), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "arrow-left-button",
        name: "Previous Image",
        onClick: this.previousImage
      }, /*#__PURE__*/React.createElement(_svg["default"], {
        className: "arrow-left",
        id: "chevron-light"
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "arrow-right-button",
        name: "Next Image",
        onClick: this.nextImage
      }, /*#__PURE__*/React.createElement(_svg["default"], {
        className: "arrow-right",
        id: "chevron-light"
      })));
    }
  }]);

  return GalleryCarouselNavComponent;
}(React.Component);

exports.GalleryCarouselNavComponent = GalleryCarouselNavComponent;

_defineProperty(GalleryCarouselNavComponent, "windowExists", function () {
  return typeof window !== 'undefined';
});

_defineProperty(GalleryCarouselNavComponent, "propTypes", {
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    title: _propTypes["default"].string
  })),
  currentTitle: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired
});

_defineProperty(GalleryCarouselNavComponent, "defaultProps", {
  data: [],
  currentTitle: null
});

_defineProperty(GalleryCarouselNavComponent, "resizeDebounceWait", 300);

_defineProperty(GalleryCarouselNavComponent, "maxImageScaleWidth", 1200);

_defineProperty(GalleryCarouselNavComponent, "minImageScaleWidth", 600);

var _default = GalleryCarouselNavComponent.windowExists() ? (0, _keyboardCommands.keyboardCommands)( // @ts-ignore
GalleryCarouselNavComponent, [{
  keys: 'right',
  connectCommand: function connectCommand(props, event, component) {
    component.nextImage();
  }
}, {
  keys: 'left',
  connectCommand: function connectCommand(props, event, component) {
    component.previousImage();
  }
}]) : GalleryCarouselNavComponent;

exports["default"] = _default;